













import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
  // import ChartHeader from './ChartHeader.vue'
  @Component({
    name: 'BarDashed',
    components: {
      Chart
      // ChartHeader
    }
  })
export default class extends Vue {
    @Prop({ default: '#00B66C' }) private color!: string
    @Prop({}) private dataList!: any
    @Prop({ default: '打卡率' }) private type!: string

    private chartId: string = ''
    private legend: any[] = [{ name: '参考标准', color: '#666666' }, { name: this.type, color: this.color }]
    private option: any = {
      tooltip: {
        formatter: '{a0}: {c0}%'
      },
      grid: {
        top: 20,
        right: 10,
        left: 50,
        bottom: 75
      },
      title: {
        // subtext: '占比（%）'
      },
      // legend: {
      //   data: ['参考标准', '当前占比'],
      //   icon: 'circle',
      //   right: 0,
      //   top: 10,
      //   itemWidth: 6
      // },
      xAxis: [{
        type: 'category',
        data: ['很差', '较差', '一般', '良好', '优秀'],
        splitLine: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          interval: 0
        }
      }],
      yAxis: [{
        type: 'value',
        // max: 100,
        splitLine: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: '#999999',
          formatter: '{value}%'
        }
      }],
      series: [
        {
          name: this.type,
          type: 'bar',
          data: [],
          // label: {
          //   color: '#333',
          //   show: true,
          //   position: 'top'
          // },
          itemStyle: {
            color: this.color
          },
          barWidth: 20
        }
      ]
    }
    get chart() {
      return this.$refs.chart as any
    }
    @Watch('dataList', { immediate: true, deep: true })
    onDataChange(val: any) {
      if (!this.dataList.length) return
      if (this.dataList.length >= 10) {
        // console.log('设置DataZoom')
        this.option.dataZoom = [
          {
            bottom: 0,
            type: 'slider',
            startValue: 0,
            endValue: 9,
            backgroundColor: '#fff',
            fillerColor: '#eee',
            dataBackground: {
              lineStyle: {
                color: '#fff'
              },
              areaStyle: {
                color: '#fff'
              }
            }
          }]
      } else {
        // console.log('取消DataZoom')
        this.option.dataZoom = null
      }
      let names = []
      let data = []
      this.dataList.map((item: any) => {
        names.push(this.$fn.substring(item.classroomName, 8))
        data.push(item.clockInProportionStr)
      })
      this.option.xAxis[0].data = names
      this.option.series[0].data = data
      this.$nextTick(() => {
        this.chart.setOption(this.option)
      })
    }
    created() {
      this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    }
}
